import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
// Chakra imports
import {
  Flex,
  SimpleGrid,
  Text,
  Box,
  Button,
  useColorModeValue,
  useToast,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Radio,
  RadioGroup,
  Stack,
  Icon,
} from '@chakra-ui/react';
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import SelectField from 'components/fields/SelectField';
import Card from 'components/card/Card';
import Axios from 'axios';
import { API_SERVER } from 'config/constant';
import { json, useNavigate, useParams } from 'react-router-dom';
import {
  getCompanyList,
  getSelectCreator,
  getSelectCohortsNames,
  getCohortsByCreatorId,
} from 'utils/creator/creator';
import { getCountries } from 'utils/company/companyService';
import {
  addLearner,
  getLearnerById,
  learnerAdd,
  updateLearner,
} from 'utils/leaner/leaner';
import OnToast from 'components/alerts/toast';
import { FaLeaf, FaTrash } from 'react-icons/fa';
import { FaUpload, FaFileExcel } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';
import { MdOutlineCloudUpload } from 'react-icons/md';
import Dropzone from 'views/admin/main/ecommerce/settingsProduct/components/Dropzone';
import { checkvalidity } from 'utils/subscriptionPlans/subscriptionPlan';
import { HashLoader } from 'react-spinners';
const CreatorCreation = () => {
  const isInvalid = true;
  const stroage = JSON.parse(localStorage.getItem('user'));
  const [selectDisable, setselectDisable] = useState<boolean>(null);
  let storageCreatorId = '';
  if (stroage.data.role === 'Creator') {
    storageCreatorId = stroage.data.id;
  }
  const toast = useToast();
  const { id } = useParams();
  const navigate = useNavigate();
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const textColorSecondary = 'secondaryGray.600';
  const [companyOptions, setCompanyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [creatorOptions, setCreatorOptions] = useState([]);
  const [StoreOption, setStoreOption] = useState('Mannual');
  const [isButtonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [indicate, setIndicate] = useState<boolean>(false);
  const [emptyInfo, setEmptyInfo] = useState([]);
  const [alert, setAlert] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [cohortsOptions, setCohortsOptions] = useState([]);
  const [creatorChortsName, setCreatorChortsName] = useState(); //add this
  const [specificInvalidIds, setspecificInvalidIds] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({
    value: 'Active',
    label: 'Active',
  });
  const inputRefs = useRef<{ [key: string]: HTMLInputElement | null }>({});

  const [loadingdata, setLoadingdata] = useState(false);
  const [existingEmails, setExistingEmails] = useState<string[]>([]);
  type FormData = {
    [key: string]: {
      lenUserName: string[]; // Ensure lenUserName is an array of strings
      lenMail: string[];
      lenCountryId: string[];
      lenDepartment: string[];
      lenDesignation: string[];
      lenAge: string[];
      lenGender: string[];
      leanerId: number[];
    };
  };
  const inputRef = useRef(null);
  let creatorChortsNameValue = null;
  const additionalStyle = setIndicate
    ? {
        borderColor: 'red' /* add additional styles when setIndicate is true */,
      }
    : {};
  const [formData, setFormData] = useState({
    lenCompanyId: '',
    chId: [],
    lenCreatorId: storageCreatorId !== '' ? storageCreatorId : '',
    lenStatus: 'Active',
  });
  const [formDatas, setFormDatas] = useState<FormData>({
    '0': {
      lenUserName: [],
      lenMail: [],
      lenCountryId: [],
      lenDepartment: [],
      lenDesignation: [],
      lenAge: [],
      lenGender: [],
      leanerId: [],
    },
  });
  const [noOfRows, setNoOfRows] = useState<any>(1);
  const [rows, setRows] = useState([{}]);
  interface OptionType {
    value: string;
    label: string;
  }
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
  }
  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: '#e0e5f2 !important',
      border: '1px solid',
      background: 'transparent',
      width: '130px',
      padding: '0 !important',
    }),
  };
  const selectDatas = async (companyid: any) => {
    let data = {
      companyId: companyid,
    };
    const selectCreator = await getSelectCreator(JSON.stringify(data));
    if (selectCreator?.status !== 'Success')
      return console.log('getSelectCreator Error :', selectCreator?.message);
    setCreatorOptions(selectCreator?.data);
  };
  useEffect(() => {
    if (stroage.data.role !== 'Creator') {
      selectDatas(formData.lenCompanyId);
    }
  }, [formData.lenCompanyId]);
  const mappedCompanyOptions = Array.isArray(companyOptions)
    ? companyOptions.map((company) => ({
        value: company.cpId,
        label: company.cpCompanyName,
      }))
    : [];
  const mappedCountryOptions = Array.isArray(countryOptions)
    ? countryOptions.map((country) => ({
        value: country.value, // Change 'Id' to 'value'
        label: country.label,
      }))
    : [];
  const handleBack = () => {
    navigate('/admin/superadmin/learner/');
  };
  const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Others', label: 'Others' },
  ];
  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
  ];
  const date = new Date();
  const getYear = date.getFullYear();
  const getMonth = (date.getMonth() + 1).toString().padStart(2, '0');
  const getDate = date.getDate().toString().padStart(2, '0');
  const getHours = date.getHours().toString().padStart(2, '0');
  const getMinutes = date.getMinutes().toString().padStart(2, '0');
  const isoFormatDate = `${getYear}-${getMonth}-${getDate}`;
  const [isHovering, setIsHovering] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);

  // Prevent scrolling of body when mouse is inside table
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (isHovering && tableRef.current) {
        // Prevent vertical scroll on body
        if (e.deltaY !== 0) {
          e.preventDefault();
          // Scroll horizontally based on vertical scroll movement
          tableRef.current.scrollLeft += e.deltaY;
        }
      }
    };

    // Add event listener for scroll on window
    if (isHovering) {
      window.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      window.removeEventListener('wheel', handleWheel);
    }

    return () => {
      // Cleanup the event listener
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHovering]);
  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    selectedOption?: any,
  ) => {
    const { name, value } = e.target;

    // If a selectedOption is provided, set the value of that field in the formData state
    if (selectedOption) {
      setFormData({ ...formData, [name]: selectedOption.value });
    } else {
      // Set the value of the field to the current value of the target
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleChangeField = (e: any, rowId: any) => {
    const { name, value } = e.target;
    const fieldName = name.split('-')[0]; // Extract the field name
    setFormDatas((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };

  const handleCountryChange = (selectedOption: any, rowIndex: string) => {
    setFormDatas((prevData) => ({
      ...prevData,
      [rowIndex]: {
        ...prevData[rowIndex],
        lenCountryId: selectedOption.value,
      },
    }));
  };
  const handleGenderChange = (selectedOption: any, rowIndex: string) => {
    setFormDatas((prevData) => ({
      ...prevData,
      [rowIndex]: {
        ...prevData[rowIndex],
        lenGender: selectedOption.value,
      },
    }));
  };
  const [allCohortsOptions, setAllCohortsOptions] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const result = await getLearnerById(id);
          if (result?.status !== 'Success') {
            return;
          }
          setFormData(result?.data);
        }
        const countriesResult = await getCountries();
        if (countriesResult?.status !== 'Success') {
          return;
        }
        setCountryOptions(countriesResult?.data);
        const companyResult = await getCompanyList();
        if (companyResult?.status !== 'Success') {
          return;
        }
        setCompanyOptions(companyResult?.data);
        const creatorResult = await getSelectCreator();
        if (creatorResult?.status !== 'Success') {
          return;
        }
        setCreatorOptions(creatorResult?.data);
        if (stroage.data.role === 'Creator') {
          setselectDisable(true);
          setFormData({
            ...formData,
            lenCompanyId: creatorResult?.data[0].CompanyId || '',
            chId: creatorResult?.data[0].value || '',
          });
        }
        const data = stroage.data;
        const cohortsResult = await getSelectCohortsNames(JSON.stringify(data));
        if (cohortsResult?.status !== 'Success') {
          return;
        }

        setAllCohortsOptions(cohortsResult?.data); // Set all cohorts
        setCohortsOptions(cohortsResult?.data); // Initially show all cohorts
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };
    fetchData();
  }, [id]);
  const handleCompanyChange = (selectedOption: OptionType | null) => {
    const selectedCompanyId = selectedOption ? selectedOption.value : null;
    const newFilteredCohortsOptions = cohortsOptions.filter(
      (cohort) => cohort.chCompanyId === selectedCompanyId,
    );
    setCohortsOptions(newFilteredCohortsOptions);
    setFormData({
      ...formData,
      lenCompanyId: selectedOption ? selectedOption.value : '',
      lenCreatorId: '',
    });
  };
  const handleCreatorChange = async (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setFormData({
        ...formData,
        lenCreatorId: selectedOption.value,
        lenCompanyId: selectedOption.CompanyId,
      });
      const cohortsResult = await getCohortsByCreatorId(selectedOption.value);
      if (cohortsResult?.status !== 'Success') {
        return;
      }
      if (cohortsResult?.data) {
        const uniqueCohorts = [
          ...new Set(cohortsResult.data.map((cohort: any) => cohort.label)),
        ];
        const mappedCohorts = uniqueCohorts.map((cohortName: any) => {
          const cohort = cohortsResult.data.find(
            (cohort: any) => cohort.label === cohortName,
          );
          return {
            value: cohort.value,
            label: cohort.label,
            chId: cohort.value,
          };
        });
        setCohortsOptions(mappedCohorts);
      } else {
        setCohortsOptions([]);
      }
    } else {
      setFormData({
        ...formData,
        lenCreatorId: '',
      });
      const allCohortsResult = await getSelectCohortsNames();
      if (allCohortsResult?.status !== 'Success') {
        return;
      }
      if (allCohortsResult?.data) {
        const mappedAllCohorts = allCohortsResult.data.map((cohort: any) => ({
          value: cohort.label,
          label: cohort.label,
          chId: cohort.value,
        }));
        setCohortsOptions(mappedAllCohorts);
      } else {
        setCohortsOptions([]);
      }
    }
  };
  const handleCohortsChange = (selectedOption: any) => {
    setFormData({
      ...formData,
      chId: selectedOption ? [selectedOption.value] : [],
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Collect all emails from the form
    const allEmails = Object.values(formDatas)
      .map((row: any) => row.lenMail)
      .flat();

    // Check for duplicate emails
    const duplicateEmails = allEmails.filter(
      (email: string, index: number) => allEmails.indexOf(email) !== index,
    );

    // If there are duplicates, show the error toast
    if (duplicateEmails.length > 0) {
      toast({
        title: 'Duplicate Email Found',
        description: `The following emails are duplicated: ${duplicateEmails.join(
          ', ',
        )}`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (!formData.lenCompanyId) {
      setMsg('Please select the company name');
      setToastStatus('error');
      setAlert(true);
      return false;
    }
    if (!formData.lenCreatorId) {
      setMsg('Please select the Creator Name');
      setToastStatus('error');
      setAlert(true);
      return false;
    }

    let formDataStringified = JSON.stringify(formData);
    let formDatasStringified = JSON.stringify(formDatas);
    const formDatasParsed = JSON.parse(formDatasStringified);
    const emptyInfo = Object.entries(formDatasParsed).reduce(
      (acc: { position: string; name: string }[], [key, value]) => {
        const lenUserNameLength = (value as { lenUserName?: any }).lenUserName
          ?.length;
        const lenMailValues = (value as { lenMail?: any }).lenMail || [];
        const lenMailLength = (value as { lenMail?: any }).lenMail?.length;
        const lenDepartmentLength = (value as { lenDepartment?: any })
          .lenDepartment?.length;
        const lenDesignationLength = (value as { lenDesignation?: any })
          .lenDesignation?.length;
        if (lenUserNameLength === 0 || lenMailLength === 0) {
          if (lenUserNameLength === 0) {
            acc.push({ position: key, name: 'lenUserName' });
          }
          if (lenMailLength === 0) {
            acc.push({ position: key, name: 'lenMail' });
          }
        }
        return acc;
      },
      [],
    );
    if (emptyInfo.length !== 0) {
      const mergerPosition = `${emptyInfo[0].name}-${emptyInfo[0].position}`;
      const inputFieldElement = document.getElementById(mergerPosition);
      if (inputFieldElement) {
        setspecificInvalidIds([mergerPosition]);
        inputFieldElement.focus();
      }
    } else {
      try {
        setButtonDisabled(true);
        setLoadingdata(true);
        const userDetails = JSON.parse(localStorage.getItem('user'));

        let dataforvalidity = { ...(userDetails?.data || {}), type: 'learner' };

        const isAdmin = userDetails?.data?.role === 'Admin';

        let limitCheck = Infinity; // Set default to unlimited for admin
        let learnercountcheck = 0;
        if (!isAdmin) {
          const Check = await checkvalidity(JSON.stringify(dataforvalidity));

          learnercountcheck = Check.findcreatorlearners;

          limitCheck = Check.limitedLearners;
        }

        if (learnercountcheck >= limitCheck) {
          setMsg('Learner Limit Reached');
          setToastStatus('error');
          setAlert(true);
          return;
        }

        const rowCount = rowKeys.length;

        // ✅ Also ensure new additions don’t exceed limit
        if (rowCount + learnercountcheck <= limitCheck) {
          let data = {
            defaultData: formData,
            learnerData: formDatas,
          };
          const result = await addLearner(JSON.stringify(data));
          if (result?.status === 'ValidationFailure') {
            setButtonDisabled(false);
            setspecificInvalidIds(result?.mails);
            setMsg(result?.message);
            setToastStatus('error');
            setAlert(true);
            return;
          } else if (result?.status === 'existingLearnerEmails') {
            setButtonDisabled(false);
            setspecificInvalidIds(result?.mails);
            setMsg(result?.message);
            setToastStatus('error');
            setAlert(true);
            return;
          } else if (result?.status === 'existingCreatorEmails') {
            setButtonDisabled(false);
            setspecificInvalidIds(result?.mails);
            setMsg(result?.message);
            setToastStatus('error');
            setAlert(true);
            return;
          } else if (result?.status === 'Failure') {
            setButtonDisabled(false);
            setMsg('Failed to Create Learner');
            setToastStatus('error');
            setAlert(true);
            return;
          } else if (result?.status === 'Success') {
            setMsg('Learner Stored');
            setToastStatus('success');
            setAlert(true);
            setTimeout(() => {
              navigate('/admin/superadmin/learner');
            }, 200);
          }
        } else {
          setMsg('Learner Limit Reached');
          setToastStatus('error');
          setAlert(true);
          return;
        }
      } catch (error) {
        setButtonDisabled(false);
      } finally {
        setLoadingdata(false);
      }
    }
  };
  const handleAddRow = () => {
    setNoOfRows(noOfRows + 1);

    const newRowId = noOfRows; // Use noOfRows directly as the new row ID
    setFormDatas((prevFormDatas) => ({
      ...prevFormDatas,
      [newRowId.toString()]: {
        lenUserName: [],
        lenMail: [],
        lenCountryId: [],
        lenDepartment: [],
        lenDesignation: [],
        lenAge: [],
        lenGender: [],
        leanerId: [],
      },
    }));
    const allEmails = Object.values(formDatas)
      .map((row: any) => row.lenMail)
      .flat();

    // Check for duplicate emails
    const duplicateEmails = allEmails.filter(
      (email: string, index: number) => allEmails.indexOf(email) !== index,
    );

    // If there are duplicates, show the error toast
    if (duplicateEmails.length > 0) {
      toast({
        title: 'Duplicate Email Found',
        description: `The following emails are duplicated: ${duplicateEmails.join(
          ', ',
        )}`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }
  };

  useEffect(() => {
    setRows(
      Array.from({ length: noOfRows }, (_, index) => ({ id: index + 1 })),
    );
  }, [noOfRows]);

  const [excelData, setExcelData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryString = event.target.result;
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(data);
    };
    reader.readAsBinaryString(file);
  };
  const dragNdrop1 = (event: any) => {
    var fileName = URL.createObjectURL(event.target.files[0]);
    var preview = document.getElementById('preview');
    var previewImg = document.createElement('img');
    previewImg.setAttribute('src', fileName);
    preview.innerHTML = '';
    preview.appendChild(previewImg);
  };
  const drag1 = () => {
    const uploadFileParent = document.getElementById('uploadFile')
      .parentNode as HTMLElement;
    if (uploadFileParent) {
      uploadFileParent.className = 'draging dragBox';
    }
  };

  const drop1 = () => {
    const uploadFileParent = document.getElementById('uploadFile')
      .parentNode as HTMLElement;
    if (uploadFileParent) {
      uploadFileParent.className = 'dragBox';
    }
  };
  const drag = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.target.files[0];
    setSelectedFile(file);
    if (
      file &&
      (file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls'))
    ) {
      handleFileUpload(event);
    } else {
      console.log('Please select a valid Excel file.');
    }
  };

  const dragNdrop = async (event: any) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    setSelectedFile(file);
    if (inputRef.current) inputRef.current.value = '';
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(jsonData as any);
    };
    reader.readAsBinaryString(file);
  };

  const removeFile = () => {
    setSelectedFile(null);
    setNoOfRows(1);
    setFormDatas({});
  };
  const ArrayComparisonComponent = (excelhead: any) => {
    const array1 = [
      'S.No',
      'LEARNER NAME',
      'LEARNER MAIL',
      'LEARNER DEPARTMENT',
      'LEARNER DESIGNATION',
      'LEARNER COUNTRY',
      'LEARNER AGE',
      'LEARNER GENDER',
    ];
    const array2 = excelhead;
    if (excelhead) {
      const arraysAreEqual = (arr1: any, arr2: any) => {
        if (arr1.length !== arr2.length) {
          return false;
        }
        return arr1.every(
          (element: any, index: any) => element === arr2[index],
        );
      };
      if (!arraysAreEqual(array1, array2)) {
        setMsg('This file does not match');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
      return true;
    } else {
      setMsg('this file does not match');
      setToastStatus('error');
      setAlert(true);
      return false;
    }
  };
  useEffect(() => {
    if (excelData.length > 0) {
      const filteredData = excelData.filter(
        (row) =>
          row.length > 0 &&
          row.some(
            (cell: any) => cell !== undefined && cell !== null && cell !== '',
          ),
      );
      if (filteredData.length > 1) {
        if (ArrayComparisonComponent(filteredData[0] ?? null)) {
          setNoOfRows(filteredData.length - 1);
          const updatedFormDatas: any = {};
          filteredData.slice(1).forEach((item, index) => {
            const counId = mappedCountryOptions.find(
              (country) =>
                country?.label?.toLowerCase() === item[5]?.toLowerCase(),
            )?.value;
            updatedFormDatas[index.toString()] = {
              lenUserName: item[1],
              lenMail: item[2],
              lenDepartment: item[3],
              lenDesignation: item[4],
              lenCountryId: counId,
              lenAge: item[6],
              lenGender: item[7],
              leanerId: [],
            };
          });

          setFormDatas((prevFormDatas) => ({
            ...prevFormDatas,
            ...updatedFormDatas,
          }));
        }
      }
    }
  }, [excelData]);
  const handleFileInput = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };
  const expectedColumnHeaders = [
    'learner Name',
    'learner Mail',
    'learner Department',
    'learner Designation',
    'learner Country',
    'learner Age',
    'learner Gender',
    'ACTION',
  ];
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const brand = useColorModeValue('brand.500', 'brand.400');
  const handleDeleteRow = (rowId: any) => {
    setFormDatas((prevData) => {
      const newData = { ...prevData };
      delete newData[rowId];
      return newData;
    });
  };
  const rowKeys = Object.keys(formDatas);
  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        marginTop={'75px'}
        position={'relative'}
      >
        <Card alignItems={'center'}>
          <Card
            bg={'linear-gradient(to bottom, #7551ff, #3311db)'}
            w={'100%'}
            h={{ base: '170', sm: '170', md: '300', lg: '300' }}
            position={'relative'}
            alignItems={'center'}
          ></Card>
          <Card
            mb={{ base: '0px', xl: '20px' }}
            width={{ base: '95%', md: '70%' }}
            marginTop={'-120px'}
          >
            <Flex
              direction="row"
              w={'100%'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Box>
                <Text
                  color={useColorModeValue('secondaryGray.900', 'white')}
                  fontSize="2xl"
                  fontWeight="700"
                  mb="20px"
                >
                  Learner {id ? 'Updation' : 'Creation'}
                </Text>
              </Box>
              <SimpleGrid
                columns={{ sm: 1, md: 2, lg: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
              >
                <RadioGroup
                  value={StoreOption}
                  onChange={(e) => setStoreOption(e)}
                >
                  <Stack direction="row">
                    <Radio value="Mannual">
                      <strong>Add Learner Manually </strong>{' '}
                    </Radio>
                    <Radio value="Excel">
                      <strong>Add By Excel</strong>
                    </Radio>
                  </Stack>
                </RadioGroup>
              </SimpleGrid>
            </Flex>
            <SimpleGrid
              columns={{ sm: 1, md: 2, lg: 3 }}
              spacing={{ base: '20px', xl: '20px' }}
            >
              <SelectField
                mb="0px"
                me="30px"
                id="lenCompanyId"
                name="lenCompanyId"
                label="Learner Company Name"
                options={companyOptions}
                onChange={handleCompanyChange}
                isRequired={true}
                value={
                  companyOptions.find(
                    (option) => option.value === formData.lenCompanyId,
                  ) || null
                }
                isDisabled={selectDisable}
                isClearable={true}
                styles={customStyles}
              />
              <SelectField
                mb="0px"
                me="30px"
                id="lenCreatorId"
                name="lenCreatorId"
                label="Creator Name"
                options={creatorOptions}
                onChange={handleCreatorChange}
                isRequired={true}
                value={
                  creatorOptions.find(
                    (option) => option.value === formData.lenCreatorId,
                  ) || null
                }
                isDisabled={selectDisable}
                isClearable={true}
                styles={customStyles}
              />
              <SelectField
                mb="0px"
                me="30px"
                id="Cohorts"
                name="chCohortsNmae"
                label="Cohort Name"
                options={cohortsOptions}
                onChange={handleCohortsChange}
                value={
                  cohortsOptions.find(
                    (option) =>
                      parseInt(option.value) === parseInt(formData.chId[0]),
                  ) || null
                }
                isClearable={true}
                styles={{}}
              />
              <InputField
                mb="0px"
                me="30px"
                id="creatorEntryDate"
                label="Learner Entry Date"
                type="date-local"
                defaultValue={isoFormatDate}
                disabled={true}
              />
            </SimpleGrid>
            {StoreOption === 'Excel' && (
              <SimpleGrid
                columns={{ sm: 1, md: 2, lg: 2 }}
                spacing={{ base: '20px', xl: '20px' }}
                style={{ marginTop: '20px' }}
              >
                <div style={{ position: 'relative' }}>
                  {!selectedFile && (
                    <Box
                      maxW="100%"
                      display="flex"
                      flexDir="column"
                      alignItems="center"
                      background="#f9f9f9"
                      cursor="pointer"
                      borderRadius="20px"
                      padding="10px"
                      onClick={() => inputRef.current?.click()}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (
                          e.dataTransfer.files &&
                          e.dataTransfer.files.length > 0
                        ) {
                          dragNdrop({
                            target: { files: e.dataTransfer.files },
                          });
                          e.dataTransfer.clearData();
                        }
                      }}
                    >
                      <Icon
                        as={MdOutlineCloudUpload}
                        w="80px"
                        h="80px"
                        color={textColor}
                      />
                      <Text
                        mb="12px"
                        fontSize="lg"
                        w="100%"
                        maxW="100%"
                        fontWeight="700"
                        color={textColor}
                        whiteSpace="pre-wrap"
                      >
                        Drop your Excel here, or{' '}
                        <Text
                          as="span"
                          fontSize="lg"
                          fontWeight="700"
                          color={brand}
                        >
                          click to browse
                        </Text>
                      </Text>
                    </Box>
                  )}
                  {selectedFile && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    >
                      <FaFileExcel
                        style={{
                          color: '#1D6F42',
                          cursor: 'pointer',
                          height: '100px',
                          width: 'auto',
                        }}
                      />
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '0.875rem',
                            fontWeight: 'bold',
                            color: '#1B2559',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            marginLeft: '5px',
                          }}
                        >
                          {selectedFile.name}
                        </span>
                        <button
                          onClick={removeFile}
                          style={{
                            marginLeft: '5px',
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                        >
                          <FaTimes />
                        </button>
                      </span>
                    </div>
                  )}
                  <input
                    type="file"
                    onChange={(event) => dragNdrop(event)}
                    style={{ display: 'none' }}
                    ref={inputRef}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    href={require('../sampleexcel/AtlantisSampleLearneData.xlsx')}
                    download
                  >
                    <FaFileExcel
                      className="Dwonload-Excel"
                      style={{
                        color: '#1D6F42',
                        cursor: 'pointer',
                        height: '100px',
                        width: 'auto',
                      }}
                    />
                  </a>
                  <Box>
                    <p
                      className="Excelhead"
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                        color: '#1B2559',
                      }}
                    >
                      You can download a sample excel file by clicking on the
                      icon.
                    </p>
                    <Text
                      className="ExcelNote"
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                        color: '#1B2559',
                      }}
                    >
                      <span style={{ color: 'red' }}></span>For a smooth upload,
                      please ensure that the country names are spelled correctly
                      and genders match the format provided in the sample file.
                    </Text>
                  </Box>
                </div>
              </SimpleGrid>
            )}
            <Box
              // m={'50px 0 20px 0'}
              // w={'100%'}
              // overflowX={'auto'}
              className="learner-scroll"
              m={'50px 0 20px 0'}
              w={'100%'}
              ref={tableRef}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              overflowX="auto"
            >
              <Table
                boxShadow={'1px 2px 17px #f7f7f7'}
                border={'2px solid #f1f1f1'}
                mb={'30px'}
              >
                <Thead whiteSpace={'nowrap'}>
                  <Tr>
                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Name<span style={{ color: 'red' }}>*</span>
                    </Th>

                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Mail<span style={{ color: 'red' }}>*</span>
                    </Th>

                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Department
                    </Th>
                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Designation
                    </Th>

                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Country
                    </Th>
                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Age
                    </Th>
                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      learner Gender
                    </Th>
                    <Th
                      color={'#000'}
                      fontFamily={'Nunito Sans'}
                      borderRight={'2px solid #f1f1f1'}
                    >
                      Action
                    </Th>
                  </Tr>
                </Thead>
                <Tbody whiteSpace={'nowrap'}>
                  {rowKeys.map((rowKey, i) => (
                    <Tr key={rowKey} whiteSpace={'nowrap'}>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <InputField
                          mb="0px"
                          me="30px"
                          id={`lenUserName-${rowKey}`}
                          name={`lenUserName-${rowKey}`}
                          placeholder="eg. jhon "
                          w={'150px'}
                          onChange={(e: any) => handleChangeField(e, rowKey)}
                          value={formDatas[rowKey]?.lenUserName || ''}
                          style={{
                            borderColor:
                              isInvalid &&
                              specificInvalidIds.includes(
                                `lenUserName-${rowKey}`,
                              )
                                ? 'red'
                                : '',
                          }}
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <InputField
                          mb="0px"
                          me="30px"
                          id={`lenMail-${rowKey}`}
                          name={`lenMail-${rowKey}`}
                          placeholder="eg. Mail@sample.com"
                          onChange={(e: any) => handleChangeField(e, rowKey)}
                          value={formDatas[rowKey]?.lenMail || ''}
                          w={'250px'}
                          autoComplete="off"
                          disabled={id ? true : false}
                          style={{
                            borderColor:
                              isInvalid &&
                              specificInvalidIds.includes(`lenMail-${rowKey}`)
                                ? 'red'
                                : '',
                          }}
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <InputField
                          mb="0px"
                          me="30px"
                          id={`lenDepartment-${rowKey}`}
                          name={`lenDepartment-${rowKey}`}
                          placeholder="eg. sales "
                          onChange={(e: any) => handleChangeField(e, rowKey)}
                          value={formDatas[rowKey]?.lenDepartment || ''}
                          style={{
                            borderColor:
                              isInvalid &&
                              specificInvalidIds.includes(
                                `lenDepartment-${rowKey}`,
                              )
                                ? 'red'
                                : '',
                          }}
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <InputField
                          mb="0px"
                          me="30px"
                          id={`lenDesignation-${rowKey}`}
                          name={`lenDesignation-${rowKey}`}
                          placeholder="eg. new joinee"
                          onChange={(e: any) => handleChangeField(e, rowKey)}
                          value={formDatas[rowKey]?.lenDesignation || ''}
                          style={{
                            borderColor:
                              isInvalid &&
                              specificInvalidIds.includes(
                                `lenDesignation-${rowKey}`,
                              )
                                ? 'red'
                                : '',
                          }}
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <SelectField
                          mb="0px"
                          me="30px"
                          id={`lenCountryId-${rowKey}`}
                          name={`lenCountryId-${rowKey}`}
                          options={mappedCountryOptions}
                          // onChange={handleCountryChange}
                          onChange={(selectedOption: any) =>
                            handleCountryChange(selectedOption, rowKey)
                          }
                          value={
                            mappedCountryOptions.find(
                              (option) =>
                                option.value ===
                                formDatas[rowKey]?.lenCountryId,
                            ) || null
                          }
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <InputField
                          mb="0px"
                          me="30px"
                          id={`lenAge-${rowKey}`}
                          name={`lenAge-${rowKey}`}
                          placeholder="eg. 30"
                          type="text"
                          onChange={(e: any) => {
                            const value = e.target.value;
                            if (value === '' || /^[1-9]\d*$/.test(value)) {
                              handleChangeField(e, rowKey);
                            }
                          }}
                          value={formDatas[rowKey]?.lenAge || ''}
                        />
                      </Td>
                      <Td p={'0.5rem 1.0rem'} borderRight={'2px solid #f1f1f1'}>
                        <SelectField
                          mb="0px"
                          me="30px"
                          id={`lenGender-${rowKey}`}
                          name={`lenGender-${rowKey}`}
                          options={genderOptions}
                          onChange={(selectedOption: any) =>
                            handleGenderChange(selectedOption, rowKey)
                          }
                          autoComplete="off"
                          value={
                            genderOptions.find(
                              (option) =>
                                option.value ===
                                (formDatas[rowKey]?.lenGender || ''),
                            ) || null
                          }
                        />
                      </Td>
                      <Td
                        p="0.5rem 1.0rem"
                        borderRight="2px solid #f1f1f1"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        {i > 0 && (
                          <FaTrash
                            color="lightgray"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDeleteRow(rowKey)}
                          />
                        )}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              <Flex mb={'20px'}>
                <Button
                  onClick={handleAddRow}
                  fontSize="sm"
                  color={'#190793'}
                  border={'1px solid #190793'}
                  bg={'transparent'}
                  _hover={{ bg: '#11047a', color: '#fff' }}
                >
                  Add Row
                </Button>
              </Flex>
            </Box>
            <Flex justify="space-between">
              <Button
                fontSize="sm"
                borderRadius="16px"
                border={'1px solid #00000024'}
                w={{ base: '128px', md: '148px' }}
                h="46px"
                mt="20px"
                mr="20px"
                bg={'transparent'}
                _hover={{ bg: '#11047a', color: '#fff' }}
                onClick={handleBack}
              >
                Cancel
              </Button>
              <Button
                mt="20px"
                variant="darkBrand"
                fontSize="sm"
                borderRadius="16px"
                w={{ base: '128px', md: '148px' }}
                h="46px"
                ms="auto"
                onClick={handleSubmit}
              >
                {id ? 'Update' : 'Save'}
              </Button>
            </Flex>
          </Card>
        </Card>
      </Box>
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};
export default CreatorCreation;
